// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToolTwoToneSvg from "@fishx/icons-svg/es/asn/ToolTwoTone";
import FishxIcon from '../components/FishxIcon';

var ToolTwoTone = function ToolTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToolTwoToneSvg
  }));
};

ToolTwoTone.displayName = 'ToolTwoTone';
export default React.forwardRef(ToolTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ToolTwoTone.js
// module id = 4274
// module chunks = 0